import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';
import { useContextRouting } from '@core/context';
import { getTypeRoute } from '@core/util';

import { LinkGoBackBase } from './LinkGoBackBase';
import { LinkGoBackBaseProps } from './interface-link';

export const LinkGoBack = ({
  redirection,
  children,
  ...restProps
}: LinkGoBackBaseProps): JSX.Element => {
  // TODO: a component must not be dependent on useContextRouting, or on have logic on how our routes are built
  const { keyRoute } = useContextRouting();
  const { t } = useTranslation(Translate.common.LINK);
  const previousRoute = getTypeRoute(keyRoute).breadcrumb?.at(-1);

  return (
    <LinkGoBackBase {...restProps} redirection={previousRoute ?? redirection}>
      {children || t('back.title')}
    </LinkGoBackBase>
  );
};
